<template>
  <side-panel-inner on-close="NewsIndexPage">
    <div slot="header" v-if="nextArticle.title" class="c-panel__header-title">
      <p>
        <a href="#" @click.prevent="goToNextArticle" class="next-article">
          <span>Next news story:</span>
          <br />
          {{ nextArticle.title }}
        </a>
      </p>
      <div class="sticky-cover"></div>
      <div class="sticky-title" :class="{ show: showSticky }">
        {{ currentArticle.title }}
      </div>
    </div>

    <div slot="header" class="c-panel__header-title" v-else>
      <div class="sticky-cover"></div>
      <div class="sticky-title" :class="{ show: showSticky }">
        {{ currentArticle.title }}
      </div>
    </div>

    <loading v-if="!article_loaded" />
    <article v-else role="article">
      <header class="full-width">
        <section class="meta">
          <p>
            <inline-list :withLead="true" :ordered="true">
              <li
                v-for="(category, index) in currentArticle.categories"
                :key="category.id"
              >
                {{ category.name }}
                <span
                  v-if="
                    index != Object.keys(currentArticle.categories).length - 1
                  "
                  >,&nbsp;</span
                >
              </li>
            </inline-list>
          </p>

          <p>
            <date
              title="Posted "
              :date="currentArticle.created_time"
              :showIcon="true"
            ></date>
            &nbsp;
            <meta-field show-icon icon="share">
            <base-button as-link @click="addQrCode = true">Share Article</base-button>
            </meta-field>
          </p>
        </section>
        <h1>{{ currentArticle.title }}</h1>
      </header>

      <section class="content">
        <section
          class="header-image full-width"
          slot="header-image"
          v-if="currentArticle.default_image && image_loaded"
        >
          <image-loader
            :image="currentArticle.default_image"
            :alt="`Banner image for ${currentArticle.title}`"
          />
        </section>

        <article class="article-content">
          <div
            class="c-element-container"
            :class="{ [`c-element-container--${element.type}`]: true }"
            v-for="(element, index) in currentArticle.elements"
            :key="index"
          >
            <pb-element :element="forRender[index]"></pb-element>
          </div>
        </article>
      </section>
    </article>
    <modal v-if="addQrCode" show-close-button @close="addQrCode = false" class="ta-left">
      <h1 slot="header">Create QR Code</h1>
      <qr-generator />
    </modal>
  </side-panel-inner>
</template>

<script>
import Date from "@/components/elements/Date";
import PbElement from "@/components/PbElement";
import InlineList from "@/components/Lists/InlineList";
import ImageLoader from "@/components/elements/ImageLoader";
import MetaField from "@/components/MetaField"
import QrGenerator from "@/components/contentElements/modals/TheQrGenerator"

import { mapState } from "vuex";
require("intersection-observer");

export default {
  name: "SingleNews",

  data() {
    return {
      image_loaded: false,
      article_loaded: false,
      showSticky: false,
      addQrCode: false
    };
  },

  beforeMount() {
    const vm = this;
    const articleId = this.$route.params.id;

    this.$store.dispatch("News/read", articleId).then(() => {
      this.$store.commit(
        "pageElements/setPageElements",
        this.$store.state.News.currentArticle.elements
      );
      vm.image_loaded = true;
      vm.article_loaded = true;
    });
  },

  updated() {
    /**
     * Intersection observer for showing sticky menu
     */
    if (document.querySelector("header.full-width")) {
      var observer;

      var options = {
        root: null,
        rootMargin: "0px",
        threshold: 0,
      };

      observer = new IntersectionObserver(this.ioCallback, options);
      observer.observe(document.querySelector("header.full-width"));
    }
  },

  computed: {
    ...mapState("News", ["currentArticle", "articles"]),

    nextArticle() {
      return {};
      if (this.articles.length > 0) {
        const currentIndex = this.articles.findIndex(
          (item) => item.id === this.currentArticle.id
        );
        if (currentIndex >= 0) {
          const nextArticle = this.articles[currentIndex + 1];
          if (!nextArticle.website_posted_date) {
            return nextArticle;
          } else {
            return {};
          }
        }
      } else {
        return {};
      }
    },
    prevLink() {
      if (this.articles.length > 0) {
        const currentIndex = this.articles.findIndex(
          (item) => item.id === this.currentArticle.id
        );
        if (currentIndex >= 0) {
          return this.articles[currentIndex - 1];
        }
      } else {
        return {};
      }
    },
    forRender() {
      {
        return this.$store.getters["pageElements/forRender"];
      }
    },
  },

  methods: {
    ioCallback(entries, observer) {
      const entryToCheck = entries[0];
      if (!entryToCheck.isIntersecting) {
        this.showSticky = true;
      } else {
        this.showSticky = false;
      }
    },
    goToNextArticle() {
      const vm = this;
      const { nextArticle } = this;
      this.$store.commit("News/SET_ARTICLE", []);
      this.image_loaded = false;

      this.$store.dispatch("News/read", nextArticle.id).then((resp) => {
        this.$store.commit(
          "pageElements/setPageElements",
          this.$store.state.News.currentArticle.elements
        );
        this.image_loaded = true;
        vm.$router.push({
          name: "NewsRead",
          params: { id: nextArticle.id },
        });
      });
    },
  },

  components: {
    Date,
    PbElement,
    InlineList,
    ImageLoader,
    MetaField,
    QrGenerator
  },
};
</script>

<style scoped lang="scss">
.sticky-cover {
  width: 100%;
  top: 0;
  right: 0;
  height: 90px;
  position: absolute;
  background: white;
  z-index: -1;
}
.sticky-title {
  position: absolute;
  left: 0;
  width: 100%;
  background: #f3f6f6;
  padding: 20px;
  top: -30px;
  z-index: -2;
  transition: all ease-in-out 0.2s;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.11);
  font-size: 16px;
  &.show {
    top: 90px;
  }
}
.full-width {
  margin-left: -2em;
  min-width: calc(100% + 4em);
  box-sizing: border-box;

  @media screen and (min-width: 1024px) {
    margin-left: -3em;
    min-width: calc(100% + 6em);
  }

  @media screen and (min-width: 1170px) {
    margin-left: -6em;
    min-width: calc(100% + 12em);
  }
}

.header-image {
  max-height: 300px;
  overflow: hidden;

  position: relative;

  margin-bottom: 20px;

  &:before {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    content: "";
    box-shadow: 0 0 10px 6px rgba(0, 0, 0, 0.11);
    z-index: 2;
    height: 1px;
  }
}

.next-article {
  color: $colour-nhs-mid-grey;
  font-weight: lighter;
  text-decoration: none;
  position: relative;
  display: block;
  cursor: pointer;
  font-size: 18px;
  line-height: 1.2;
  font-family: $font-frutiger-light;
  padding-right: 20px;

  span {
    color: $colour-nhs-core-blue;
    font-weight: bold;
    font-size: 16px;
    line-height: 1.1;
    font-family: $font-frutiger-bold;
  }

  &:after {
    position: absolute;
    right: 0;
    top: 50%;
    margin-top: -14px;
    display: block;
    content: " ";
    background-image: url("/assets/arrow.svg");
    background-size: 28px 28px;
    height: 28px;
    width: 28px;
    transition: all ease-in-out 0.2s;
  }

  &:hover {
    &:after {
      right: -5px;
    }
  }
}

article {
  img {
    min-height: 200px;
    width: 100%;
  }
}

header {
  background: #f0f5fb;
  margin-top: -110px;
  padding-top: 110px;

  padding-left: 2em;
  padding-right: 2em;
  min-width: calc(100% + 4em);
  box-sizing: border-box;

  h1 {
    padding-bottom: 0.67em;
    margin-bottom: 0;
  }

  @media screen and (min-width: 1024px) {
    padding-left: 3em;
    padding-right: 3em;
    min-width: calc(100% + 6em);
  }

  @media screen and (min-width: 1170px) {
    padding-left: 6em;
    padding-right: 6em;
    min-width: calc(100% + 12em);
  }
}
</style>
